(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["stories"]) return;
  try {
    
$(document).one("shopify:section:select",'#shopify-section-stories',function(e){


var myElement = $('#shopify-section-stories');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });     
}else{
$('body').animate({ scrollTop: topPos }); 
}    

$(document).one("shopify:section:deselect",'#shopify-section-stories',function(e){                           
      
                           
$(document).one("shopify:section:select",'#shopify-section-stories',function(e){
var myElement = $('#shopify-section-stories');
var topPos = myElement[0].offsetTop;

if($(window).width() < 600) { 
$('#index').animate({ scrollTop: topPos });    
}else{
$('body').animate({ scrollTop: topPos });  
}    
});                       
                           
                           

});
});  
$(document).on("shopify:section:select",'#shopify-section-stories',function(e){
story();
setTimeout(function() { 
scrollswiper(); 
},200);  
$('body').addClass('editing editstories');
$(document).one("shopify:section:deselect",function(e){
$('body').removeClass('editstories');
})

});   
              

  } catch(e) { console.error(e); }
})();

})();
